import { createTranslations } from '@npco/common-utils-translations'

export const setupFlowDownloadStageTranslations = createTranslations({
  title: 'Manage all of your finances with Zeller App.',
  description:
    'See every account, card, transaction, and contact in your Zeller Account from one convenient app, now with Tap to Pay.',
  point1: 'Accept contactless payments with your smartphone.',
  point2: 'Transfer funds to your accounts or external recipients.',
  point3: 'Issue and manage cards securely from anywhere.',
  point4: 'Real-time reporting across every payment, account, and card.',
})
